'use strict';

var _ = require('lodash');
var toastr = require('toastr');
var SaveValidationService = function SaveValidationService() {
  function cleanRow(row) {
    delete row.isNewlyAdded;
    delete row.isRowEditable;
    delete row.originalRowId;
    delete row._old;
    delete row._original;
    delete row.lastUpdatedAt;
    delete row.lastUpdatedBy;
  }
  function cleanNestedRows(row) {
    _.forEach(row, function (value) {
      if (_.isArray(value)) {
        _.forEach(value, function (nestedRow) {
          cleanRow(nestedRow);
        });
      }
    });
  }
  function clearAllNestedRows(rows) {
    var clearedRows = _.cloneDeep(rows);
    _.forEach(clearedRows, function (row) {
      cleanRow(row);
      cleanNestedRows(row);
    });
    return clearedRows;
  }
  function validateByColumnValidations(editedRows, allRows, columns, isCustomValidation) {
    var valid = true;
    var clearedRows = clearAllNestedRows(editedRows);
    _.forEach(clearedRows, function (row) {
      if (!valid) {
        return;
      }
      _.forEach(columns, function (column) {
        if (!valid || !_.isFunction(column.validation)) {
          return;
        }
        var cell = {
          row: _.findIndex(allRows, row),
          column: column.datafield,
          text: column.text
        };
        var value = row[cell.column];
        if (column.cellsRendererName === 'percentageRender') {
          //percentage validations are configured to work on visible data range (0-100) and not internal one (0-1)
          //that's why we need to multiply by 100
          value = Math.round(value * 100);
        }
        var result = column.validation(cell, value, allRows);
        if (_.isBoolean(result)) {
          valid = result;
        } else {
          if (isCustomValidation || result.result === false) {
            toastr.error((cell.text ? cell.text + ' - ' : '') + result.message);
          }
          valid = result.result;
        }
      });
    });
    return valid;
  }
  return {
    validateByColumnValidations: validateByColumnValidations
  };
};
SaveValidationService.$inject = [];
module.exports = SaveValidationService;